import React from 'react';

import Button from 'Components/Button';
// This is going to look exactly like the featured printable
// so we’ll keep the styles and even classname the same for consistency.
import styles from '../GamePrintableFeatured/GamePrintableFeatured.scss';
import ConnectedFormattedMessage from 'Containers/ConnectedFormattedMessage';
import ConnectedFormattedImage from 'Containers/ConnectedFormattedImage';

const GameHandbook = ({ slug, title }) => {
  const graphic = require(`./handbook-thumb-${slug}.png`);
  const downloadUri = `https://schools-cdn.tinybop.com/assets/handbooks/en/tinybop-${slug}-handbook.pdf`;
  return (
    <a
      className="GamePrintableFeatured is-hoverable-parent"
      href={downloadUri}
      target="_blank"
    >
      <ConnectedFormattedImage
        className="GamePrintableFeatured__graphic"
        src={graphic}
        altId={`model.${slug}.title`}
      />
      <div className="GamePrintableFeatured__copy">
        <div className="GamePrintableFeatured__title">
          <ConnectedFormattedMessage id={`model.${slug}.title`} />{' '}
          <ConnectedFormattedMessage id="game_handbook.title_fragment" />
        </div>
        <p className="GamePrintableFeatured__description">
          <ConnectedFormattedMessage id="game_handbook.description" />
        </p>
        <Button
          clickHandler={() => null}
          buttonType="tertiary-outline"
          ctaIcon="caret"
          label={
            <ConnectedFormattedMessage id="game_printable.view_button_label" />
          }
        />
      </div>
    </a>
  );
};

export default GameHandbook;
